// extracted by mini-css-extract-plugin
export default {"container":"+6IJmM3z5VNWEVhCBNy8tg==","card-fields":"Vv4h7-t223wptWXdMQGDFw==","asides":"etrn+7XKH6LdLXw7teaGBw==","footnote":"sYu04fLbpF2UtNKs9OXk4w=="};